import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ArrowCounterclockwise } from 'react-bootstrap-icons';
import {
    selectFetchingSuggestions,
    selectAddress,
    selectAddressResponseFormat,
    selectFetchingAddress,
    selectFetchAddress,
    selectSearchFilters,
    selectSuggestionsOptions,
    selectTransactionCount,
    selectDisplayControls,
    getAddressAsync,
    getSuggestionAsync,
    setSearchFilters,
    setAddressView,
    setShowPopup,
    selectShowPopup,
    resetTransactionCount,
    selectQuery,
    selectTheme,
    flipTheme,
} from './PavFormSlice';
import {
    Container,
    Row, Col,
    Form,
    Table,
    Button,
    ButtonGroup, ToggleButton,
} from 'react-bootstrap';
import {StaticMap, Marker, Source, Popup} from 'react-map-gl';
import {AsyncTypeahead, Highlighter} from "react-bootstrap-typeahead";
import InputGroup from "react-bootstrap/InputGroup";
import Jumbotron from "react-bootstrap/Jumbotron";


export function PavForm() {

    let address = useSelector(selectAddress);
    address = address.address;
    const suggestionsOptions = useSelector(selectSuggestionsOptions);
    const fetchingSuggestions = useSelector(selectFetchingSuggestions);
    const fetchingAddress = useSelector(selectFetchingAddress);
    const fetchAddress = useSelector(selectFetchAddress);
    const searchFilters = useSelector(selectSearchFilters);
    const transactionCount = useSelector(selectTransactionCount);
    const displayControls = useSelector(selectDisplayControls);
    const addressResponseFormat = useSelector(selectAddressResponseFormat);
    const query = useSelector(selectQuery);
    const theme = useSelector(selectTheme);
    const dispatch = useDispatch();

    return (
        <Container fluid>
            <Row>
                <Col lg="6" md="12" sm="12">
                    <Container fluid>
                        <Jumbotron>
                            <Row>
                                <Col>
                                    {RenderControlsForm(dispatch, searchFilters, displayControls, fetchAddress, address, query)}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {RenderTransactions(dispatch, transactionCount)}
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {RenderSearchForm(
                                        dispatch,
                                        fetchingSuggestions,
                                        suggestionsOptions,
                                        searchFilters
                                    )}
                                </Col>
                            </Row>
                            <br/>
                            <br/>
                            <Row>
                                <Col>
                                    {RenderAddress(dispatch, fetchingAddress, address, addressResponseFormat)}
                                </Col>
                            </Row>
                            <br/>
                            <Row>
                                <Col lg="12">
                                    <a
                                      className="btn btn-info"
                                      href="https://developer.geoscape.com.au/sign-up"
                                      target="_blank"
                                      rel="noopener noreferrer">
                                        <strong>SIGN UP</strong>
                                    </a>
                                </Col>
                            </Row>
                        </Jumbotron>
                    </Container>
                </Col>
                <Col lg="6" md="6" className="d-none d-sm-block d-sm-none d-md-block">
                    {RenderMap(dispatch, address, theme)}
                </Col>
            </Row>
        </Container>
    );
}

function RenderMap(dispatch, address, theme) {
    let longitude = 149.1244524;
    let latitude = -35.3081552;
    let zoom = 16
    if (address !== undefined && address.properties !== undefined && Object.keys(address.properties).length !== 0) {
        longitude = address.geometry.coordinates[0];
        latitude = address.geometry.coordinates[1];
    }
    const token = 'pk.eyJ1IjoiYXJhbWJ1bGFqbSIsImEiOiJja2Fyc281ZW4wOTAwMzBuemdhbHo4cWV2In0.ATr6_R8M3eamlcUNLKd2JQ'
    const viewport = {
        longitude: longitude,
        latitude: latitude,
        zoom: zoom
    }
    let mapTheme = 'mapbox://styles/mapbox/light-v10?optimize=true';
    let icon = 'Icon_pin1.png';
    if (theme === 'black') {
        mapTheme = 'mapbox://styles/mapbox/dark-v10?optimize=true';
        icon = 'Icon_pin1_orange.png';
    }
    const showPopup = useSelector(selectShowPopup);
    const pinH = 24;
    const pihW = 20.5;
    const renderPin = function() {
        if (Object.keys(address.properties).length !== 0){
            return <img src={icon} width={pihW} height={pinH} alt="Point"
                        onClick={() => dispatch(setShowPopup(!showPopup))}/>
        }
    }

    const renderTooltip = function() {
        return (
        <div className="custom-scroll">
            <Table striped size="sm" className={"tooltip-table"} width={"50%"}>
                <tbody>
                {
                    Object.keys(address.properties).map((key) => (
                        <tr key={key}>
                            <td align="right">{key}</td>
                            <td align="left">{address.properties[key]}</td>
                        </tr>
                    ))
                }
                </tbody>
            </Table>
        </div>
        )
    }
    return (
        <>
            <StaticMap
                width='100%'
                height='84.5%'
                transitionDuration={200}
                {...viewport}
                mapboxApiAccessToken={token}
                mapStyle={mapTheme}
                key={`map-${theme}`}
                id={`map-${theme}`}
            >
                <Source type="geojson" data={{...address, type: "Feature"}}>
                    <Marker latitude={latitude} longitude={longitude} offsetLeft={-pihW/2} offsetTop={-pinH}>
                        {renderPin()}
                    </Marker>
                </Source>
                {showPopup &&
                <Popup
                  latitude={latitude}
                  longitude={longitude}
                  closeButton={true}
                  closeOnClick={false}
                  onClose={() => dispatch(setShowPopup(false))}
                  anchor="top" >
                    {renderTooltip()}
                </Popup>
                }
            </StaticMap>
            {Object.keys(address.properties).length !== 0 &&
            <Button variant="dark" onClick={() => dispatch(flipTheme())}>
                <p>
                    <strong>Longitude:</strong> {longitude}, <strong>Latitude:</strong> {latitude}
                </p>
            </Button>
            }
        </>
    )
}

function RenderControlsForm(dispatch, searchFilters, displayControls, fetchAddress, address) {
    let stateTerritoryFilters = searchFilters.filter(s => (s.name === 'stateTerritory'));
    let datasetFilters = searchFilters.filter(s => (s.name === 'dataset'));
    let addressTypeFilters = searchFilters.filter(s => (s.name === 'addressType'));
    let excludeAliasesFilter = searchFilters.filter(s => (s.name === 'excludeAliases'));
    let CRSFilters = searchFilters.filter(s => (s.name === 'CrsAccept'));
    let MaxResultsFilters = searchFilters.filter(s => (s.name === 'maxNumberOfResults'));

    let cxl2 = 2; // ≥ 1200px
    let cxl3 = 3; // ≥ 1200px
    let clg = 3; // ≥ 992px
    let cmd = 3; // ≥ 768px
    let csm = 6; // ≥ 576px
    let cxs = 6; // < 576px

    return (
        <Form className="form-filter-controls" >
            <Form.Label>Predictive Address Verification Demo</Form.Label>
            <Form.Row>
                <Col xl="12">
                    <Form.Group controlId="pavMaxNumberOfResults">
                        {MaxNumberOfResultsFilter(dispatch, MaxResultsFilters)}
                    </Form.Group>
                </Col>
                <Col xl={cxl2} lg={clg} md={cmd} sm={csm} xs={cxs}>
                    <Form.Group controlId="pavStateTerritory">
                        {StateTerritoryFilter(dispatch, stateTerritoryFilters)}
                    </Form.Group>
                </Col>
                <Col xl={cxl3} lg={clg} md={cmd} sm={csm} xs={cxs}>
                    <Form.Group controlId="pavDataset">
                        {DatasetFilter(dispatch, datasetFilters)}
                    </Form.Group>
                </Col>
                <Col xl={cxl2} lg={clg} md={cmd} sm={csm} xs={cxs}>
                    <Form.Group controlId="pavAddressType">
                        {AddressTypeFilter(dispatch, addressTypeFilters)}
                    </Form.Group>
                </Col>
                <Col xl={cxl3} lg={clg} md={cmd} sm={csm} xs={cxs}>
                    <Form.Group controlId="pavExcludeAliases">
                        {ExcludeAliasesFilter(dispatch, excludeAliasesFilter)}
                    </Form.Group>
                </Col>
                <Col xl={cxl2} lg={clg} md={cmd} sm={csm} xs={cxs}>
                    <Form.Group controlId="pavCRS">
                        {CRSAccept(dispatch, CRSFilters, fetchAddress, address)}
                    </Form.Group>
                </Col>
            </Form.Row>
        </Form>
    )
}

function RenderTransactions(dispatch, transactionCount) {
    return (
        <p>
            <b>Transactions:</b> <b>{transactionCount.toFixed(1)}</b>
            <ArrowCounterclockwise
                title="Reset"
                onClick={() => dispatch(resetTransactionCount())}
            />
        </p>
    )
}

function CreateCheckboxGroup(options, callback) {
    return (
        <>
            <Form.Label title={options[0].name}>{options[0].displayName}</Form.Label>
            {
                options.map((option) => (
                    <Form.Check
                        type={option.type}
                        id={`${option.name}-${option.value}`}
                        key={`${option.name}-${option.value}`}
                        title={option.value}
                        label={option.label}
                        value={option.value}
                        name={option.name}
                        checked={option.enabled}
                        onChange={() => {
                            callback({
                                option: option
                            })
                        }}
                    />
                ))
            }
        </>
    )
}

function StateTerritoryFilter(dispatch, searchFilters) {
    let callback = e => dispatch(setSearchFilters(e));

    return (
        <>
            {CreateCheckboxGroup(searchFilters, callback)}
        </>
    )
}

function DatasetFilter(dispatch, searchFilters) {
    let callback = e => dispatch(setSearchFilters(e));

    return (
        <>
            {CreateCheckboxGroup(searchFilters, callback)}
        </>
    )
}

function AddressTypeFilter(dispatch, searchFilters) {
    let callback = e => dispatch(setSearchFilters(e))

    return (
        <>
            {CreateCheckboxGroup(searchFilters, callback)}
        </>
    )
}

function ExcludeAliasesFilter(dispatch, searchFilters) {
    let callback = e => dispatch(setSearchFilters(e))

    return (
        <>
            {CreateCheckboxGroup(searchFilters, callback)}
        </>
    )
}

function CRSAccept(dispatch, searchFilters, fetchAddress, address) {
    let callback = e => {dispatch(setSearchFilters(e))};
    if (fetchAddress) dispatch(getAddressAsync([{id: address.id}], searchFilters));

    return (
        <>
            {CreateCheckboxGroup(searchFilters, callback)}
        </>
    )
}

function MaxNumberOfResultsFilter(dispatch, searchFilters) {
    let callback = e => dispatch(setSearchFilters(e));
    const option = searchFilters[0];

    return (
        <>
            <Form.Label title={option.name}>{option.displayName}</Form.Label>
            <br/>
            <b>{option.value}</b>
            <Form.Control
                type="range"
                min="1"
                max="20"
                value={option.value}
                custom
                onChange={e => {
                    callback({
                        value: e.target.value,
                        option: option
                    });
                }}
            />
        </>
    )
}

function RenderSearchForm(dispatch, fetchingSuggestions, suggestionsOptions, searchFilters) {
    return (
        <Form>
            <Form.Group controlId="pavForm">
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <img
                              alt="Search"
                              src="Icon_search1.png"
                              height={"20"}
                            />
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <AsyncTypeahead
                        id="address-search"
                        autoFocus={true}
                        clearButton={true}
                        minLength={3}
                        selectHintOnEnter={true}
                        isLoading={fetchingSuggestions}
                        labelKey="address"
                        filterBy={() => true}
                        onSearch={query => dispatch(getSuggestionAsync(query, searchFilters))}
                        onChange={suggestion => dispatch(getAddressAsync(suggestion, searchFilters))}
                        options={suggestionsOptions}
                        useCache={false}
                        placeholder="Start typing an Australian address"
                        renderMenuItemChildren={(option, props) => (
                            <Highlighter search={props.text}>
                                {option[props.labelKey]}
                            </Highlighter>
                        )}
                    />
                </InputGroup>
            </Form.Group>
        </Form>
    )
}

function RenderAddress(dispatch, fetchingAddress, address, addressResponseFormat) {
    const properties = address.properties || {};
    const addressJson = JSON.stringify(address, null, 2);
    const formatJson = addressResponseFormat.filter(f => (f.label === 'JSON'))[0].enabled
    const formatInfo = addressResponseFormat.filter(f => (f.label === 'INFO'))[0].enabled

    return (
        <Container>
            <Row>
                <Col>
                    {formatInfo &&
                    <div className="custom-scroll">
                        <Table striped size="sm">
                            <tbody>
                            {
                                Object.keys(properties).sort().map((key) => (
                                    <tr key={key}>
                                        <td align="right">{key.split('_').map(s => (s[0].toUpperCase() + s.substr(1))).join(' ')}:</td>
                                        <td align="left" className="dataAccent">{key.includes('locality') && properties[key] ? properties[key].split(',').join(', ') : properties[key]}</td>
                                    </tr>
                                ))
                            }
                            </tbody>
                        </Table>
                    </div>
                    }
                    {formatJson &&
                    <Form.Control as="textarea" value={addressJson} rows="20" className="custom-scroll" readOnly/>
                    }
                    <br/>
                    <ButtonGroup toggle>
                        {addressResponseFormat.map(radio => (
                            <ToggleButton
                                key={radio.label}
                                className="btn-sm"
                                type="radio"
                                name="radio"
                                value={radio.label}
                                checked={radio.enabled}
                                onChange={() => dispatch(setAddressView(radio))}
                            >
                                {radio.label}
                            </ToggleButton>
                        ))}
                    </ButtonGroup>
                </Col>
            </Row>
        </Container>
    )
}
